import { Link } from 'react-router-dom'
import { formatEur, type OpenItemsResponse } from '@wf/shared'

/** Vorschau der offenen Posten (fertig, noch nicht bezahlt) mit Summe und Link auf die volle Liste. */
export function OpenItemsPreview({ data }: { data: OpenItemsResponse | undefined }) {
  if (!data) return null

  if (data.count === 0) {
    return (
      <div className="wf-ovpanel">
        <h3 className="wf-ovpanel__title">Offene Posten</h3>
        <p className="wf-ov-empty">Keine offenen Posten – alles bezahlt 🎉</p>
      </div>
    )
  }

  const preview = data.items.slice(0, 5)
  return (
    <div className="wf-ovpanel">
      <div className="wf-ovpanel__head">
        <h3 className="wf-ovpanel__title">Offene Posten</h3>
        <span className="wf-ov-total">{formatEur(data.totalCents)}</span>
      </div>
      <ul className="wf-openlist">
        {preview.map((item) => (
          <li key={item.id} className="wf-openrow">
            <span className="wf-openrow__main">
              <span className="wf-openrow__title">{item.plate ?? item.vehicleModel ?? '—'}</span>
              <span className="wf-openrow__sub">
                {item.customerName ?? 'Laufkundschaft'}
                {item.nr ? ` · ${item.nr}` : ''}
              </span>
            </span>
            <span className="wf-openrow__value">{formatEur(item.valueCents)}</span>
          </li>
        ))}
      </ul>
      <Link className="wf-ov-link" to="/open">
        {data.count > preview.length ? `Alle ${data.count} ansehen` : 'Alle ansehen'}
      </Link>
    </div>
  )
}
